import { render, staticRenderFns } from "./AdvGiftChoiceBlock.vue?vue&type=template&id=e6c38df6"
import script from "./AdvGiftChoiceBlock.vue?vue&type=script&lang=js"
export * from "./AdvGiftChoiceBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports